import { frLocale } from '../../lib/PST.Web.Common/src/services/i18n/locales/fr';
import { frLocaleFrontOffice } from '../i18n/locales/fr';
import { AuthenticationConstants } from '../../lib/PST.Web.Common/src/services/authentication/base';

const i18n = {
    locale: 'fr',
    messages: {
        ...frLocale.messages,
        ...frLocaleFrontOffice.messages,
    },
};

export const initialState = {
    i18n,
    Authentication: { loginMethod: AuthenticationConstants.LOGIN_METHOD_PROFILE_TEMP },
};
